import useFetch from './useFetch';
import config from '../../../configWrapper';

function formatUrl() {
  const url = `${config.serverUrl}/onboarding/encrypt-auth-api-start`;
  return url;
}

function requestOptions(accountId) {
  return {
    requestOptions: {
      method: 'POST',
      body: JSON.stringify({
        accountId: accountId.toString(),
      }),
    },
  };
}

export default function useOnboardingEdata(accountId) {
  // Only fetch if accountId is valid (greater than 1)
  // Account 0 = not logged in, Account 1 = system account
  const url = accountId > 1 ? formatUrl() : '';
  const options = accountId > 1 ? requestOptions(accountId) : { requestOptions: { method: 'GET' } };

  // Use the object form of useFetch so we grab the results and ignore loading/errors
  const { results } = useFetch(url, options);
  return results;
}
